<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      回龙埔站<br>
站点介绍<br>
回龙埔站位于龙平西路与吉祥中路交叉口西侧，沿龙平西路东西向布置。车站已开通 A、B、C、D 共 4 个出入口。A 出入口：龙平西路、同享路、龙岗区妇幼保健院、瑞华园、熙和园。B 出入口：龙平西路、吉祥中路、城市花园。C 出入口：龙平西路、吉祥中路、长江花园、华业玫瑰郡、回龙埔社区公园、全盛紫悦龙庭、同创九著。D 出入口：回龙埔幼儿园、回龙埔综合市场、龙埔路、延著路、爱心路、万科翰邻城<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:01	23:10	16号线	5分32秒	6分37秒<br>
田心	06:22	23:38	16号线	5分32秒	6分37秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:11	23:10	16号线	5分50秒	6分钟-9分钟<br>
田心	06:28	23:38	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:11	00:10	16号线	5分50秒	6分钟-9分钟<br>
田心	06:28	00:38	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A 出入口:<br>
龙平西路、同享路、龙岗区妇幼保健院、瑞华园、熙和园<br><br>
B 出入口:<br>
龙平西路、吉祥中路、城市花园<br><br>
C 出入口:<br>
龙平西路、吉祥中路、长江花园、华业玫瑰郡、回龙埔社区公园、全盛紫悦龙庭、同创九著<br><br>
D 出入口:<br>
回龙埔幼儿园、回龙埔综合市场、龙埔路、延著路、爱心路、万科翰邻城<br>
公交换乘信息<br><br>

  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>